// MOBILE SUBMENU

jQuery(document).ready(function($){

  $('.c-sidebar-nav-mobile__btn').click(function() {
    $(this).toggleClass('active');
    $(this).next('.c-sidebar-nav').toggleClass('active');
  });

});
